import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import { IconButton, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { enqueueSnackbar } from "notistack";
import React, { useContext } from "react";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { AuthContext } from "../../../contexts/AuthContext";
import { getGroupEmail } from "../../../helpers/authUser";
import theme from "../../../theme";

const useStyles = makeStyles((theme) => ({
    container: {
        width: 350,
        height: 180,
        border: `2px solid ${theme.colors.neutral['200']}`,
        borderRadius: 24,
        padding: 16,
    },
    headerIcon: {
        color: theme.colors.neutral['400'],
        width: 60,
        height: 60,
    },
    subText: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 400,
        color: theme.colors.neutral['500'],
    },
    link: {
        maxWidth: '24ch',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: theme.colors.cyan['500'],
        cursor: 'pointer',
    },
    break: {
    },
}));

const ForwardDealsCard: React.FC<{}> = () => {
    const classes = useStyles();
    const { userGroup } = useContext(AuthContext);

    return (<>
        <Stack className={classes.container} spacing={1} alignItems="center" justifyContent="center">
            <ForwardToInboxOutlinedIcon className={classes.headerIcon} />
            <Typography className={classes.subText}>
                {'Forward emails with deals to: '}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                <Typography className={classes.link}
                    onClick={() => window.open(`mailto: ${getGroupEmail(userGroup)}`, '_self', 'noopener, noreferrer')}>
                    {getGroupEmail(userGroup)}
                </Typography>
                <CopyToClipboard text={`${getGroupEmail(userGroup)}`}
                    options={{ format: "text/plain" }}
                    onCopy={() => {
                        enqueueSnackbar(`Successfully copied to clipboard.`,
                            { anchorOrigin: { vertical: "bottom", horizontal: "right" }, });
                    }}>
                    <IconButton size="small" sx={{ color: theme.colors.cyan['500'] }}>
                        <ContentCopyIcon sx={{ width: 24, height: 24, }} />
                    </IconButton>
                </CopyToClipboard>
            </Stack>
        </Stack>
    </>);
}

export default ForwardDealsCard;